export const SYSTEM_STATE = '/system-state';

export const ROUTE_HOME_SYSTEM_STATE = SYSTEM_STATE + '/home';
export const ROUTE_SYSTEM_STATE_DEVICE = SYSTEM_STATE + '/:serialNumber';

export const systemStateRoutes = [ROUTE_HOME_SYSTEM_STATE, ROUTE_SYSTEM_STATE_DEVICE];
